<template>
  <div class="new-tree-design">
    <div
      :class="[
        'test-group-container cursor-pointer flex flex-col justify-center',
        { 'not-allowed-select': testGroupNode.value[isNotAllowedSelectProp] },
        { 'show-tooltip': isGeneticTestDuplicate },
        { 'not-allowed-current-menu-bg': !isAllowedSelect || testGroupNode.value[isNotAllowedSelectProp] },
        !testGroupNode.value[this.selectProp] &&
          (addOnRequiredMoreNoOfTubesTests.map(i => i.id).includes(testGroupNode.id) ||
          addOnExpiredTestList.includes(testGroupNode.id)) || addOnFixedVaVwTestWithParents.has(testGroupNode.id)
          ? 'add-on-require-more-tube' : '',
      ]"
      :style="isExpandArrowDown && testGroupNode.descendants.length > 0 ? 'padding-bottom: 12px;' : 'height: 46px;'"
      :data-tooltip="geneticTestTooltip"
    >
      <div class="flex justify-between items-center px-3" @click="handleClickTest(testGroupNode)">
        <div class="flex items-center">
          <img 
            :src="prefix[prefixStyle]" 
            alt="prefix" 
            :class="[
              'prefix', 
              { 'not-allowed-checkbox' : testGroupNode.value[isNotAllowedSelectProp] || !isAllowedSelect }
            ]"
          >
          <span class="flex items-center" style="gap: 6px;">
            <p :class="['ml-3 panel-title', { 'not-allowed-current-menu-color': !isAllowedSelect || testGroupNode.value[isNotAllowedSelectProp] }]">
              {{ getItemNameByLanguage(testGroupNode.value) }}
            </p>
            <!-- Info Icon with Tooltip -->
            <span class="info-icon-wrapper">
              <TestInfoIconPopover
                v-if="testGroupNode.value.infoIcon"
                :info-text="testGroupNode.value.infoIcon"
              />
            </span>
            <!-- DbsTickbornePopover -->
            <DbsTickbornePopover v-if="[588, 590].includes(testGroupNode.id)" />
            <!-- RegenereNewItemsPopover -->
            <RegenereNewItemsPopover v-if="regenerePopoverText" :popover-text="regenerePopoverText" />
          </span>
        </div>
        <div
          class="flex items-center mr-2"
          @click.stop="handleClickTest(testGroupNode)"
        >
          <template v-if="!shouldHideSampleTypeTags">
            <TestSampleTypeTagNew
              v-for="t in sampleTypeTagInfo.keys"
              :key="t"
              :type="sampleTypeTagType(t)"
            />
          </template>
          <span v-if="displayPrice" class="sample-price">{{ displayPrice }}</span>
        </div>
        <!-- Family Discount component - only show for Gut Zoomer -->
        <!-- <FamilyDiscountTag v-if="showFamilyDiscountTag" /> -->
        <img
          v-if="expandIcon === 'arrowDown'"
          :src="isExpandArrowDown ? arrowUpIcon : arrowDownIcon"
          alt="expand"
          class="expand-icon"
          @click.stop="isExpandArrowDown = !isExpandArrowDown"
        >
        <span 
          v-else-if="expandIcon === 'newWindow'" 
          class="material-icons-outlined small-icon"
          @click.stop="clickNewWindownIcon"
        >
          open_in_new
        </span>
        <!-- bulletList -->
        <el-popover
          v-else-if="expandIcon === 'bulletList'"
          placement="right"
          popper-class="bullet-list-popover"
          :width="220"
        >
          <div class="flex items-center">
            <p class="test-name ml-8">{{ getItemNameByLanguage(testGroupNode.value) }}</p>
          </div>
          <ul class="mt-2">
            <li 
              v-for="test in testGroupNode.value.packageTests" 
              :key="test.id" 
              class="test-list-item mb-1 pl-8"
            >
              {{ test.name }}
            </li>
          </ul>
          <template v-slot:reference>
            <svg class="middle-icon" @click.stop viewBox="0 0 24 24" fill="currentColor">
              <path d="M4 10.5c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5zm0-6c-.83 0-1.5.67-1.5 1.5S3.17 7.5 4 7.5 5.5 6.83 5.5 6 4.83 4.5 4 4.5zm0 12c-.83 0-1.5.68-1.5 1.5s.68 1.5 1.5 1.5 1.5-.68 1.5-1.5-.67-1.5-1.5-1.5zM7 19h14v-2H7v2zm0-6h14v-2H7v2zm0-8v2h14V5H7z"/>
            </svg>
          </template>
        </el-popover>
        <!--  link icon( vw only ) -->
        <div v-if="testGroupNode.value.category === 'vw'" class="flex items-center" @click.stop>
          <a v-if="testGroupNode.value.weblink" :href="testGroupNode.value.weblink" target="_blank" class="ml-1">
            <span class="material-icons-outlined insert-link-icon pt-2">
              insert_link
            </span>
          </a>
        </div>
      </div>
      <!-- arrowDown -->
      <div v-if="isExpandArrowDown && testGroupNode.descendants.length > 0 && (expandIcon === 'arrowDown' || testGroupNode.value.category === 'vw')" class="mt-2.5 mx-2 tree-node-card new-tree-children">
        <TreeNodeTest 
          v-for="node in testGroupNodeWithArrowIcon" 
          :key="node.id" 
          :test-node="node" 
          :filtered-test="filteredTest"
          :select-prop="selectProp"
          :is-not-allowed-select-prop="isNotAllowedSelectProp"
          :order-test-support-obj="orderTestSupportObj"
          :prefix="prefix"
          :add-on-desendant-list="addOnFixedVaVwTest.get(testGroupNode.id)"
        />
      </div> 
      <!-- newWindow -->
      <div @click.stop>
        <MicronutrientsDialog 
          class="cursor-auto"
          :test-group-node="testGroupNode"
          :filtered-test="filteredTest"
          :is-open-new-window="isOpenNewWindow"
          :select-prop="selectProp"
          :is-not-allowed-select-prop="isNotAllowedSelectProp"
          :order-test-support-obj="orderTestSupportObj"
          @close="isOpenNewWindow = false"
        />
      </div>
      <ItemNotAllowedDialog 
        v-if="isShowTestNotAllowedDialog"
        :is-show-dialog="isShowTestNotAllowedDialog"
        :item-category="testGroupNode.value.category"
        :item-name="testGroupNode.value.testName"
        :dialog-type="!isAllowedForPatientAge ? 'notAllowedForPatientAge' : 'notAllowedForMenu'"
        @close="isShowTestNotAllowedDialog = false"
      />
      <AddOnUnableSelectDialog 
        :is-show-dialog="addOnUnableSelectDialogVisible" 
        :test-name="testGroupNode.value.testName" 
        :unable-select-reason="addOnUnableSelectReason" 
        :add-on-remaining-stability-days="addOnRemainingStabilityDays"
        @addTestAnyway="handleAddTestAnyway"
        @close="addOnUnableSelectDialogVisible = false"
      />
      <DuplicateGeneticTestDialog
        v-if="showDuplicateGeneticTestDialog"
        :is-show-dialog="showDuplicateGeneticTestDialog"
        :test-name-list="[getItemNameByLanguage(testGroupNode.value)]"
        @close="showDuplicateGeneticTestDialog = false"
        @confirm="handleDuplicateGeneticTestConfirm"
      />
    </div>
    <!-- show micronutrients move to vw menu alert -->
    <div v-if="showMicronutrientsMoveMenuAlert" class="micronutrients-move-menu-alert flex items-center px-4 py-1">
      <span class="material-icons micronutrients-move-menu-alert-icon mr-3">info</span>
      <p>{{ $t("OrderPage[\"Starting January 6th, Micronutrients will be moved from Vibrant America tab to Vibrant Wellness tab.\"]") }}</p>
    </div>
  </div>
</template>

<script>
import DbsTickbornePopover from "../../../components/DbsTickBornePopover.vue";
import RegenereNewItemsPopover from "../../../components/RegenereNewItemsPopover.vue";
import TestInfoIconPopover from "../../../components/TestInfoIconPopover.vue";
import MicronutrientsDialog from "./va-test-tab-pane/micronutrients-dialog/index.vue";
import TreeNodeTest from "./TreeNodeTest.vue";
import ItemNotAllowedDialog from "../../ItemNotAllowedDialog.vue";
import AddOnUnableSelectDialog from './AddOnUnableSelectDialog.vue'
import DuplicateGeneticTestDialog from "./DuplicateGeneticTestDialog.vue";
import TestSampleTypeTagNew from "../../../components/TestSampleTypeTagNew.vue";
import { getSampleTypeSetsNew, getSampleTypeTagInfoFromSetsNew } from "@/utils/va-order-test/sampleTypes.js";
import { processNameAbbreviationNew } from "@/utils/va-order-test/index.js";
// import FamilyDiscountTag from "../../../family-discount/FamilyDiscountTag.vue";
import { addSelectedTest, removeSelectedTest } from "@/utils/va-order-test/testAndPanelSelection/testSelection.js";
import { bfsSearch } from "@/utils/va-order-test/testTree/bfsSearch.js";
import { isItemAllowedForCurrentMenu, isItemAllowedForPatientAge } from "../../custom-panel/customPanelCard.js";
import { getTestCardPrefix, getItemNameByLanguage } from "./testCard.js";
import { mapState, mapGetters } from 'vuex';
import moment from "moment";
import { BLOOD_SALIVA_ADDON_IDS } from "@/utils/va-order-test/testAndPanelSelection/geneticAddonConstants.js";

export default {
  components: {
    DbsTickbornePopover,
    RegenereNewItemsPopover,
    TestInfoIconPopover,
    MicronutrientsDialog,
    TreeNodeTest,
    ItemNotAllowedDialog,
    AddOnUnableSelectDialog,
    DuplicateGeneticTestDialog,
    TestSampleTypeTagNew,
    // FamilyDiscountTag
  },

  props: {
    testGroupNode: {
      type: Object,
      default: () => {},
    },
    isShowExpand: {
      type: Boolean,
      default: false,
    },
    filteredTest: {
      type: Object,
      default: () => {},
    },
    expandIcon: {
      type: String,
      default: "",
    },
    selectProp: {
      type: String,
      default: "isSelect"
    },
    isNotAllowedSelectProp: {
      type: String,
      default: "isNotAllowedSelect"
    },    
    orderTestSupportObj: {
      type: Object,
      default: () => {}
    }
  },

  data() {
    return {
      isExpandArrowDown: (this.expandIcon === "arrowDown" || this.testGroupNode.value.category === "vw")
        ? this.isShowExpand : false,
      isShowBulletList: this.expandIcon === "bulletList" ? this.isShowExpand : false,
      isOpenNewWindow: this.expandIcon === "newWindow" ? this.isShowExpand : false,
      // when click expandCollapseAll, only test group node w/ arrow icons will change.
      testGroupNodeWithArrowIcon: [65,35,51].
        includes(this.testGroupNode.id) ? [] : this.testGroupNode.descendants,
      prefix: {},
      isShowTestNotAllowedDialog: false,
      isShowAgeRestrictDialog: false,
      showDuplicateGeneticTestDialog: false,
      addOnUnableSelectDialogVisible: false,
      addOnUnableSelectReason: "Already Ordered",
      addOnRemainingStabilityDays: 1,
      arrowUpIcon: require("@/assets/orderTest/keyboard_arrow_up_black_24dp.svg"),
      arrowDownIcon: require("@/assets/orderTest/keyboard_arrow_down_black_24dp.svg")
    }
  },

  computed: {
    ...mapState(["language"]),
    ...mapState("orderTest", ["addOnFixedVaVwTest","addOnFixedVaVwTestWithParents","isAddOnOrder", "addOnRequiredMoreNoOfTubesTests", "addOnExpiredTestList", "addOnExpiredSoonAddonTests","isDbsVersion", "dbsMap"]),
    ...mapState("orderTest/user", ["userInfo"]),
    ...mapGetters("orderTest/order", ["patientAge"]),
    regenerePopoverText() {
      switch (this.testGroupNode.id) {
        case 731:
          return "Genetic Test, Face Serum 30ml, Supplement, Eye Serum";
        case 809:
          return "Genetic Test, Face Serum 20ml";
        case 803:
          return "Face Serum 30ml, Supplement, Eye Serum";
        default:
          return null;
      }
    },

    // get all tests for current testGroupNode
    testNodeList() {
      let result = [];
      bfsSearch(this.testGroupNode, result, 0);
      // remove the first node(testGroupNode itself) from result
      result.shift();
      return result;
    },

    // get checkbox style for test with different expand icons
    prefixStyle() {
      if (this.expandIcon === "bulletList") {
        return this.testGroupNode.value[this.selectProp] ? "allCheck" : "unCheck";
      }
      return getTestCardPrefix(this.testGroupNode, this.testNodeList, this.selectProp);
    },

    sampleTypeSet() {
      let { blood, nonBlood, dryIce } = this.testGroupNode.value.sampleTypeSets;
      return new Set([...blood, ...nonBlood, ...dryIce]);
    },

    sampleTypeTagInfo() {
      try {
        const setsNew = getSampleTypeSetsNew(this.testGroupNode?.value || {});
        return getSampleTypeTagInfoFromSetsNew(setsNew);
      } catch (e) {
        return { keys: [], single: "" };
      }
    },
    singleSampleTypeTagKey() {
      return this.sampleTypeTagInfo.single;
    },

    // Price shown after tags: prefer total, fallback to price
    // VA: keep 2 decimals; VW: integer only
    displayPrice() {
      try {
        const v = this.testGroupNode?.value || {};
        const price = (v.total ?? v.price);
        if (price === undefined || price === null) return "";
        const symbol = this.$store.state.currency?.symbol || "$";
        const decimals = v.category === "vw" ? 0 : 2;
        return `${symbol}${Number(price).toFixed(decimals)}`;
      } catch (e) {
        return "";
      }
    },

    isAllowedSelect() {
      return isItemAllowedForCurrentMenu(this.isDbsVersion, this.testGroupNode.value) 
        && this.isAllowedForPatientAge;
    },

    isAllowedForPatientAge() {
      return isItemAllowedForPatientAge(this.testGroupNode.value, this.orderTestSupportObj, this.patientAge);
    },

    shouldHideSampleTypeTags() {
      // Hide sample type tags for genetic addons when they are not allowed to select
      // exception: if menu is DBS version, then no need to hide sample type tags
      // because only saliva addons are available in DBS version
      if (this.isDbsVersion) {
        return false;
      }
      const testId = this.testGroupNode.id;
      const isGeneticAddon = Object.values(BLOOD_SALIVA_ADDON_IDS).some(
        ({ blood, saliva }) => blood === testId || saliva === testId
      );
      return isGeneticAddon && this.testGroupNode.value[this.isNotAllowedSelectProp] === true;
    },
    isGeneticTestDuplicate() {
      // Show tooltip for genetic tests that patient already purchased
      // The isGeneticDuplicate flag is set directly on the node by handleGeneticsTestEligibility
      // This is reactive because it's part of the test node's value object
      return !this.testGroupNode.value[this.selectProp] &&
             this.testGroupNode.value.isGeneticDuplicate === true;
    },

    geneticTestTooltip() {
      return "This genetic test was already ordered for this patient, so it can't be added again.";
    },

    showMicronutrientsMoveMenuAlert() {
      let endDate = moment(new Date("Jan 05, 2025 11:59:59 PM")).local();
      return this.testGroupNode.id === 65 && moment().local().isSameOrBefore(endDate);
    },

    // Family Bundle - Computed disabled (UI hidden)
    // showFamilyDiscountTag() {
    //   return [836, 61].includes(this.testGroupNode.id);
    // }
  },
  
  watch: {
    prefixStyle(newVal) {
      if (!["unCheck",'favUncheck'].includes(newVal) && this.expandIcon === "arrowDown") {
        this.isExpandArrowDown = true;
      }
    }
  },

  mounted() {
    if (!["unCheck",'favUncheck'].includes(this.prefixStyle) && this.expandIcon === "arrowDown") {
      this.isExpandArrowDown = true;
    }
    this.prefix = this.getPrefixPictureBySelectProp(this.selectProp);
  },


  methods: {
    sampleTypeTagType(type) {
      if (this.selectProp === "isSelectForShortcut") {
        return processNameAbbreviationNew(type);
      }
      return type;
    },

    // select or de-select test
    handleClickTest(node) {

      if (!this.isAllowedSelect) {
        this.isShowTestNotAllowedDialog = true;
        return;
      }
      if (this.isGeneticTestDuplicate) {
        // No longer show dialog, tooltip provides the information
        return;
      }
      if(this.isAddOnOrder.length > 0) {
        if(this.addOnFixedVaVwTest.has(this.testGroupNode.id)) {
          this.addOnUnableSelectDialogVisible = true
          this.addOnUnableSelectReason = "Already Ordered"
          return
        }
        if(this.addOnRequiredMoreNoOfTubesTests.map(i => i.id).includes(this.testGroupNode.id)) {
          this.addOnUnableSelectDialogVisible = true
          this.addOnUnableSelectReason = "Requires New Kit"
          return
        }
        if(this.addOnExpiredTestList.includes(this.testGroupNode.id)) {
          this.addOnUnableSelectDialogVisible = true
          this.addOnUnableSelectReason = "Expired"
          return
        }
        if(this.addOnExpiredSoonAddonTests.has(this.testGroupNode.id) && !node.value[this.selectProp]) {
          this.addOnUnableSelectDialogVisible = true
          this.addOnUnableSelectReason = "Might Expire Soon"
          this.addOnRemainingStabilityDays = this.addOnExpiredSoonAddonTests.get(this.testGroupNode.id)
          return
        }
      }

      // remove prev selected desendants tube volume if root is going to be selected 
      // to prevent add duplication
      this.isAddOnOrder.length > 0 && !node.value[this.selectProp]  && node.descendants.forEach(d => {
        if(d.value[this.selectProp]) {
        this.$store.dispatch("orderTest/addOnFixedVaVwTestTubeInfo", {root:d,isFixedVaVw:'false',isSelect:'false'}) 
        }
      });
      if (["allCheck",'favAllcheck'].includes(this.prefixStyle) && !node.value[this.selectProp]) {
        node.descendants.forEach(d => {
          removeSelectedTest(d.id, this.selectProp, this.orderTestSupportObj);
        });
      }
      else {
        node.value[this.selectProp] 
          ? removeSelectedTest(node.id, this.selectProp, this.orderTestSupportObj)
          : addSelectedTest(node.id, this.selectProp, this.orderTestSupportObj);

        // add back removed add on va vw tests
        if(this.isAddOnOrder&&this.addOnFixedVaVwTestWithParents.has(node.id)) {
          this.addOnFixedVaVwTestWithParents.get(node.id).forEach(i => {
            addSelectedTest(i, this.selectProp, this.orderTestSupportObj);
          })
        }
      }
      // remove or add tube volume for the root
      this.isAddOnOrder.length > 0 && this.$store.dispatch("orderTest/addOnFixedVaVwTestTubeInfo", {root:node,isFixedVaVw:'false',isSelect:node.value[this.selectProp] ? 'true' : 'false'}) 
    },

    handleAddTestAnyway() {
      addSelectedTest(this.testGroupNode.value.id, this.selectProp, this.orderTestSupportObj);
      this.isAddOnOrder.length > 0 && this.$store.dispatch("orderTest/addOnFixedVaVwTestTubeInfo", {root:this.testGroupNode,isFixedVaVw:'false',isSelect:this.testGroupNode.value[this.selectProp] ? 'true' : 'false'}) 
    },

    getPrefixPictureBySelectProp(selectProp) {
      if (selectProp === "isSelectForFavorite") {
        return {
          unCheck: require("@/assets/orderTest/fav-icon-empty.svg"),
          partCheck: require("@/assets/orderTest/checkbox_indeterminate_box.svg"),
          allCheck: require("@/assets/orderTest/fav-icon-filled.svg")
        }
      } else {
        return {
          unCheck: require("@/assets/orderTest/check_box_outline_blank_24px.svg"),
          partCheck: require("@/assets/orderTest/checkbox_indeterminate_box.svg"),
          allCheck: require("@/assets/orderTest/Checkbox(all).svg")
        }
      }
    },

    clickNewWindownIcon() {
      if (!this.isAllowedSelect) {
        return;
      }
      this.isOpenNewWindow = !this.isOpenNewWindow;
    },
    getItemNameByLanguage(item) {
      return getItemNameByLanguage(item, this.language);
    },

    handleDuplicateGeneticTestConfirm() {
      removeSelectedTest(this.testGroupNode.id, this.selectProp, this.orderTestSupportObj);
      this.showDuplicateGeneticTestDialog = false;
    }

  }
};
</script>

<style scoped>
.test-group-container {
  min-height: 46px;
  background: #F9FBFD;
  box-shadow: 0px 2px 6px rgba(48, 48, 48, 0.13);
  border-radius: 3.23482px;
}

.test-name {
  overflow: hidden;
  color: var(--TrueBlack, #333);
  text-overflow: ellipsis;

  /* EHR_TitleS_14_WM */
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 142.857% */
  letter-spacing: 0.1px;
}

.check-box {
  font-size: 16px;
}

.small-icon {
  font-size: 14px;
}

.expand-icon {
  width: 14px;
  height: 14px;
  cursor: pointer;
  transition: transform 0.2s ease;
}

.middle-icon {
  font-size: 16px;
  width: 16px;
  height: 16px;
  cursor: pointer;
}

.test-list-item {
  width: 204px;
  background: #F9FBFD;
  font-size: 13px;
  line-height: 29px;
  letter-spacing: 0.15px;
  color: #000000;
}

.filtered-test-highlight {
  border: 1px solid #3498DB;
}

.not-allowed-select {
  pointer-events: none;
}

.not-allowed-checkbox {
  opacity: 0.4;
}

.info-icon-size {
  min-width: 16px;
}

.prefix {
  width: 18px;
  height: 18px;
}

.panel-title {
  font-weight: 500;
  overflow: hidden;
  color: var(--TrueBlack, #333);
  text-overflow: ellipsis;

  /* EHR_TitleS_14_WM */
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px; /* 142.857% */
  letter-spacing: 0.1px;
}

.insert-link-icon {
  color: #3498DB;
  font-size: 16px;
  line-height: normal;
}

.sample-price {
  color: var(--TrueBlack, #333);
  font-family: Inter;
  font-size: 15px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px;
  letter-spacing: 0.15px;
  margin-left: auto;
  white-space: nowrap;
  min-width: 60px;
  text-align: center;
}

.test-group-container > .flex.justify-between.items-center > div:nth-child(2) {
  margin-left: auto;
  display: flex;
  align-items: center;
  gap: 8px;
}

.add-on-require-more-tube {
  background-color: #F2F2F2;
}

.not-allowed-current-menu-bg {
  background: #F2F2F2;
}

.not-allowed-current-menu-color {
  color: #979797;
}

.micronutrients-move-menu-alert {
  border-radius: 3px 0px 0px 0px;
  background:  #E8F4FD;
  font-family: Inter;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  color: #3498DB;
}
.micronutrients-move-menu-alert-icon {
  color: #3498DB;
}

/* Show tooltip for not-allowed items */
.show-tooltip {
  position: relative;
  pointer-events: auto;
}

.show-tooltip::before {
  content: '';
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  border: 6px solid transparent;
  border-bottom-color: rgba(0, 0, 0, 0.9);
  margin-top: -4px;
  pointer-events: none;
  opacity: 0;
  transition: opacity 0.2s ease;
  z-index: 999999999;
}

.show-tooltip::after {
  content: attr(data-tooltip);
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  background: rgba(0, 0, 0, 0.9);
  color: white;
  padding: 8px 12px;
  border-radius: 4px;
  font-size: 12px;
  white-space: nowrap;
  pointer-events: none;
  opacity: 0;
  margin-top: 8px;
  transition: opacity 0.2s ease;
  z-index: 999999999;
}

.show-tooltip-shortcut::after {
  white-space: normal;
  width: max-content;
  max-width: 400px;
}

.show-tooltip:hover::before {
  opacity: 1;
}

.show-tooltip:hover::after {
  opacity: 1;
}

/* Gray out not-allowed items */
.show-tooltip .panel-title {
  color: #979797 !important;
}

.show-tooltip .prefix {
  opacity: 0.4;
}

/* Hide genetic test tooltip when hovering over info icon */
.show-tooltip:has(.info-icon-wrapper:hover)::before,
.show-tooltip:has(.info-icon-wrapper:hover)::after {
  display: none;
}

/* ========================
   New Tree Design Styles
   ======================== */
.new-tree-design {
  position: relative;
}

/* Root level card styling */
.new-tree-design > .test-group-container {
  position: relative;
  background: #F9FBFD;
  border-radius: 6px;
  padding: 6px 0px;
  box-shadow: 0 4px 12px 0 rgba(26, 32, 44, 0.06);
  min-height: 30px;
}

/* Children container with connector line */
.new-tree-children {
  position: relative;
  padding-left: 20px;
  margin-top: 8px;
}

/* Main vertical line from Level 1 */
/* .new-tree-children::before {
  content: '';
  position: absolute;
  left: 8px;
  top: 4px;
  bottom: 4px;
  width: 1px;
  background: #CBD5E1;
} */

/* Root level (Level 1) checkbox color - #004879 */
.new-tree-design > .test-group-container .prefix {
  filter: brightness(0) saturate(100%) invert(15%) sepia(100%) saturate(2000%) hue-rotate(195deg) brightness(0.7);
}

/* Level 2 checkbox color - #5587BC */
.new-tree-design .new-tree-children > .test-group-container .prefix {
  filter: brightness(0) saturate(100%) invert(50%) sepia(30%) saturate(800%) hue-rotate(180deg) brightness(0.9);
}

/* Level 3+ checkbox color - #20A7C1 */
.new-tree-design .new-tree-children .new-tree-children > .test-group-container .prefix {
  filter: brightness(0) saturate(100%) invert(55%) sepia(60%) saturate(600%) hue-rotate(150deg) brightness(1);
}

</style>